/**
 * Home screen — the shell's entry-point content.
 *
 * Placeholder M0 content. Later screen tasks (Req 22-25) replace these
 * screens with the real authentication and Owner-administration flows. Each
 * screen is loaded via `React.lazy` (see `screens.tsx`) so route components are
 * code-split per route.
 */
import type { ReactElement } from "react";

export default function HomeScreen(): ReactElement {
  return (
    <section aria-labelledby="screen-heading" data-screen="home">
      <h1 id="screen-heading">Welcome to AVOS</h1>
      <p>The Autonomous Villa Operating System foundation shell.</p>
    </section>
  );
}
